






























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
// @ts-ignore
import store from "../../../store";
import TimerEnums from "../../../../enums/mode/TimerEnums";
import EventApi from "../../../api/EventsApi";

@Component({
    components: {},
})

export default class Timer extends Vue {
    @Prop({required: true}) private readonly mode!: string;

    private minutes = '00';
    private seconds = '00';
    private isReadonly = true;
    private timer: any = null;

    mounted(): void
    {
    }

    beforeDestroy(): void
    {
    }

    private get isStopwatch(): boolean
    {
        return this.mode === TimerEnums.STOPWATCH_MODE;
    }

    /**
     * Добавить минут к таймеру
     * @param minutes
     */
    public addMinutes(minutes: number): void
    {
        let value = parseInt(this.minutes, 10) + minutes;
        this.minutes = value > 9 ? `${value}` : `0${value}`;
    }

    /**
     * Остановить таймер
     * @private
     */
    public pause(): void
    {
        if (this.timer) {
            clearInterval(this.timer);
        }
        this.makeReadOnly();
    }

    /**
     * Запустить таймер
     */
    public runTimer(): void
    {
        if (this.minutes === '00' && this.seconds === '00') {
            this.$emit('stop');
            return;
        }
        this.makeReadOnly();
        this.timer = setInterval(() => {
            let totalSeconds = parseInt(this.minutes, 10) * 60 + parseInt(this.seconds, 10);
            if (this.isStopwatch) {
                totalSeconds++;
            } else {
                totalSeconds--;
            }
            const min = Math.trunc(totalSeconds / 60).toString();
            const sec = (totalSeconds % 60).toString();

            this.minutes = min.length > 1 ? min : `0${min}`;
            this.seconds = sec.length > 1 ? sec : `0${sec}`;

            if (this.seconds === '00' && this.minutes === '00') {
                clearInterval(this.timer);
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'timerEnded'});
                this.$emit('stop');
            }
        }, 1000);
    }

    /**
     * Сделать поле редактируемым
     * @private
     */
    private makeEditable(): void
    {
        this.isReadonly = false;
    }

    /**
     * Сделать поле нередактируемым
     * @private
     */
    private makeReadOnly(): void
    {
        this.isReadonly = true;
    }

    /**
     * Ввести кол-во минут
     * @private
     */
    private inputMinutes(): void
    {
        let value = parseInt(this.minutes.replace(/[^0-9]/g, ''), 10).toString();
        if (value.length > 3) {
            value = value.slice(0, 3);
        }
        this.minutes = value.length > 1 ? value : `0${value}`;
    }

    /**
     * Ввести кол-во секунд
     * @private
     */
    private inputSeconds(): void
    {
        let value = parseInt(this.seconds.replace(/[^0-9]/g, ''), 10).toString();

        const min = Math.trunc(+value / 60);
        const sec = +value % 60;

        value = sec.toString();

        this.addMinutes(min);

        if (value.length > 3) {
            value = value.slice(0, 2);
        }
        this.seconds = value.length > 1 ? value : `0${value}`;
    }

    /**
     * Сбросить таймер
     * @private
     */
    private reset(): void
    {
        this.pause();

        this.minutes = '00';
        this.seconds = '00';

        this.$emit('stop');
        this.makeReadOnly();
    }
}

